import React, { useState, useEffect } from 'react';
import { Grid, Modal } from '@material-ui/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/effect-coverflow';
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import { FaPlayCircle } from 'react-icons/fa';


import { EffectCoverflow, Pagination } from 'swiper/modules';
import { useDevice } from 'components/DeviceContext.js';

const VideosDepoimento = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const [imagesWithVideos, setImagesWithVideos] = useState([]);
    const { isMobile, isDesktop } = useDevice();

    useEffect(() => {
        // Aqui você pode fazer uma requisição para buscar os dados
        // Como os dados são estáticos, estamos apenas definindo-os diretamente
        const fetchedImagesWithVideos = [
            { imageUrl: 'http://i1.ytimg.com/vi/4Whez1a6rXE/mqdefault.jpg', videoUrl: 'https://www.youtube.com/embed/4Whez1a6rXE?si=WU2OTByuvbnpQgME' },
            { imageUrl: 'http://i1.ytimg.com/vi/SNx8-lJKa0A/mqdefault.jpg', videoUrl: 'https://www.youtube.com/embed/SNx8-lJKa0A?si=cl_iaooJMvdZgMhM' },
            { imageUrl: 'http://i1.ytimg.com/vi/N2O3YWsHEMI/mqdefault.jpg', videoUrl: 'https://www.youtube.com/embed/N2O3YWsHEMI?si=09vIIiwOqBW_abHE' },

        ];
        setImagesWithVideos(fetchedImagesWithVideos);
    }, []);

    const openModal = (videoUrl) => {
        setCurrentVideoUrl(videoUrl);
        setModalOpen(true);
    };

    const closeModal = () => {
        setCurrentVideoUrl('');
        setModalOpen(false);
    };

    return (
        <>
            <Grid container style={{ backgroundColor: 'var(--branco)', padding: '4em 0' }}>
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={false}
                    slidesPerView={isMobile ? 1 : 3}
                    spaceBetween={isMobile ? 10 : 30}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: true,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination, EffectCoverflow]}
                    className="mySwiper"
                >
                    {imagesWithVideos.map((item, index) => (
                        <SwiperSlide key={index} style={{ width: '100%', backgroundPosition: 'center', backgroundSize: 'cover' }}>
                            <Grid
                                style={{ position: 'relative', alignItems: 'center', justifyContent: 'center', display: 'flex', height: isMobile ? '' : '50vh' }}
                                onClick={() => openModal(item.videoUrl)}
                            >
                                <img style={{ height: isMobile ? '25svh' : '40vh', width: isMobile ? '80%' : '100%' }}
                                    src={item.imageUrl}
                                    alt={`Image ${index}`}
                                />
                                {index === Math.floor(imagesWithVideos.length / 2) && (
                                    <FaPlayCircle
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            fontSize: '50px',
                                            color: 'white',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => openModal(item.videoUrl)}
                                    />
                                )}
                            </Grid>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Grid>
            <Modal open={modalOpen} onClose={closeModal}>
                <Grid style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px' }}>
                    <iframe style={{width: isMobile ? '300px' : '600px', height: isDesktop ? '500px' : '300px'}}src={currentVideoUrl} title="YouTube video player" frameBorder="0" allowFullScreen></iframe>
                </Grid>
            </Modal>
        </>
    );
};

export default VideosDepoimento;
